export default [
  {
    path: '/report_bug',
    name: 'ReportBug',
    component: () => import('@/modules/reportBug/pages/ReportBug.vue'),
    meta: {
      authRequired: true,
      pageTitle: 'Report a Bug',
      handleUserAccessToPage: () => {
        return true;
      },
      breadcrumb: [
        {
          text: 'Report a bug and we will reach out to you shortly.',
          active: true,
        },
      ],
    },
  },
  {
    path: '/report_bug_jira',
    name: 'ReportBugJira',
    component: () => import('@/modules/reportBug/pages/Report-Bug-Jira.vue'),
    meta: {
      authRequired: true,
      pageTitle: 'Report a Bug to Jira',
      handleUserAccessToPage: () => {
        return true;
      },
      breadcrumb: [
        {
          text: 'Report a bug and we will reach out to you shortly.',
        },
      ],
    },
  },
];
